export var DescInfoItemType;
(function (DescInfoItemType) {
    DescInfoItemType["text"] = "text";
    DescInfoItemType["image"] = "image";
})(DescInfoItemType || (DescInfoItemType = {}));
/** 活动类型 */
export var ActivityType;
(function (ActivityType) {
    /** 开户活动 */
    ActivityType["openAccActivity"] = "openAccActivity";
    /** 兑换活动 */
    ActivityType["stampQualActivity"] = "stampQualActivity";
    /** 派发活动 */
    ActivityType["distributionActivity"] = "distributionActivity";
    /** 绑定活动 */
    ActivityType["bindCardAccActivity"] = "bindCardAccActivity";
})(ActivityType || (ActivityType = {}));
